module.exports = __webpack_public_path__ + "img/market-icon.e9043a00.png";